import type { TagListResponse } from '~/types/__generated__'

export function useApiTag() {
  const client = useStrapiClient()

  async function getTags() {
    const { data } = await client<TagListResponse>('/tags', {
      method: 'GET',
    })

    return data
  }

  async function getGroupedTags() {
    const { data } = await client<TagListResponse>('/tags', {
      method: 'GET',
      params: {
        filters: {
          $and: [
            { parent: { id: { $null: true } } },
            { children: { id: { $notNull: true } } },
          ],
        },
      },
    })

    return data
  }

  async function getFunctionsGroupedTags() {
    const { data } = await client<TagListResponse>('/tags', {
      method: 'GET',
      params: {
        filters: {
          $and: [
            { parent: { id: { $eq: 40 } } },
            { children: { id: { $notNull: true } } },
          ],
        },
      },
    })

    return data
  }

  return {
    getTags,
    getGroupedTags,
    getFunctionsGroupedTags,
  }
}
